export default "__VITE_ASSET__BVpdLlGD__"